import { officeReadyPromise } from "../init";
import {
  isAuthTokenValid,
  Models,
  getModels,
  LlmModelDetailed,
  modelsDetailedDict,
  LLMStreamV2Params,
  LLMStreamV2body,
  V2CreateResponse,
  postAudioRecording,
  documentFile,
  getLlmCaseDocumentId,
  updateDocumentContent,
} from "../utils/rest_utils";
import { logout, navSubPage, navBack } from "../commands/commands";
import { IOMain, showLoadingIndicator, hideLoadingIndicator, toastMessage } from "../utils/common";
import { TaskCategory } from "../utils/task_utils";
import { populateModelSelection } from "../utils/taskpane_utils";
import * as ce from "../utils/custom_errors";
import { camelToKebab } from "../utils/text_utils";
import { loadCaseMessages, makeLlmRequestV2, createCaseWithFiles } from "../utils/llm_utils";
import {
  getDocContentWithComments,
  getContentFile,
  setOriginalDocumentHash,
  isDocumentChanged,
} from "../utils/word_utils";
import { SettingsElement, FileUploadElement } from "../utils/ui_utils";
import { updateLanguageContent, translate } from "../locales/i18n";
import { VoiceRecorderButton } from "../utils/audio_utils";
import { getSpecialWorkflows } from "../tabs/tab_edit_document/workflow_helper";

let divLlmOutputArea: HTMLDivElement;
let llmInputArea: HTMLDivElement;
let textareaLlmInput: HTMLTextAreaElement;
let buttonSend: HTMLButtonElement;
let voiceRecorderButton: VoiceRecorderButton;
let selectLlmModel: HTMLSelectElement;

let btnSummarize: HTMLButtonElement;
let btnWorkflows: HTMLButtonElement;
let btnSummarizeQuick: HTMLButtonElement;
let btnWorkflowsQuick: HTMLButtonElement;

let btnLoadDocument: HTMLButtonElement;
let btnSaveDocument: HTMLButtonElement;
let btnLoadClause: HTMLButtonElement;
let btnSearchClause: HTMLButtonElement;

let btnChat: HTMLButtonElement;

let btnEditDocument: HTMLButtonElement;

let functionContainerEditDocument: HTMLDivElement;
let functionContainerClauses: HTMLDivElement;

let editDocumentContainer: HTMLDivElement;

let divWelcome: HTMLDivElement;
let errorContainer: HTMLDivElement;
let models: Models;
const taskCategory: TaskCategory = "chat-with-document";
let mainIOElement: IOMain;
let caseIdDocumentChat: string | null = null;
let chatIsOpen: boolean = false;

let header: HTMLElement;
let btnNavBack: HTMLButtonElement;
let btnLogout: HTMLButtonElement;
let menuOptionsContainer: HTMLDivElement;
let quickActionsContainer: HTMLDivElement;
let btnUserIcon: HTMLDivElement;

let settingsElement: SettingsElement;
let fileUploadElement: FileUploadElement;
let inputFileContainer: HTMLDivElement;

// Navigation elements
let navButtons: NodeListOf<HTMLButtonElement>;

document.addEventListener("DOMContentLoaded", async () => {
  try {
    await officeReadyPromise;
    if (!(await isAuthTokenValid())) {
      logout();
      return;
    }

    updateLanguageContent();
    await initialize();
    await populate();
  } catch (error) {
    console.error("Fehler bei der Initialisierung:", error);
  }
});

window.addEventListener("beforeunload", () => {
  localStorage.setItem("previousPage", "menu.html");
});

async function initialize() {
  console.log("Initializing menu view...");

  header = document.querySelector(".app-header") as HTMLElement;
  const chatHeader = document.querySelector(".chat-header") as HTMLElement;
  const headerActions = header.querySelector(".header-actions") as HTMLElement;
  const sidebarHelp = document.querySelector(".sidebar-help") as HTMLElement;
  const footer = document.getElementsByTagName("footer")[0] as HTMLElement;

  btnNavBack = document.getElementById("btn-nav-back") as HTMLButtonElement;
  btnNavBack.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    // window.location.reload();
    navBack();
  };

  btnLogout = document.getElementById("btn-logout") as HTMLButtonElement;
  // btnLogout.onclick = () => logout();

  errorContainer = document.getElementById("error-container") as HTMLDivElement;
  divWelcome = document.querySelector(".welcome-section") as HTMLDivElement;

  menuOptionsContainer = document.querySelector(".function-categories") as HTMLDivElement;

  quickActionsContainer = document.getElementById("quick-actions-container") as HTMLDivElement;

  btnUserIcon = document.getElementById("btn-user") as HTMLDivElement;

  functionContainerEditDocument = document.getElementById(
    "function-container-edit-document"
  ) as HTMLDivElement;
  functionContainerClauses = document.getElementById(
    "function-container-clauses"
  ) as HTMLDivElement;

  editDocumentContainer = document.getElementById("edit-document-container") as HTMLDivElement;

  // ######################## NAVIGATION SIDEBAR ##############################
  const username = localStorage.getItem("username");
  console.log("username is", username);
  if (btnUserIcon && username) {
    btnUserIcon.setAttribute("title", username);
  }

  navButtons = document.querySelectorAll(".nav-button");
  navButtons.forEach((button, index) => {
    button.onclick = () => {
      // Remove active class from all buttons
      navButtons.forEach((btn) => btn.classList.remove("active"));
      // Add active class to clicked button
      button.classList.add("active");

      // Handle navigation based on button
      switch (button.id) {
        case "nav-home":
          // Already on home page
          break;
        case "btn-logout":
          logout();
          break;
        case "nav-documents":
          navSubPage("summarize.html");
          break;
        case "nav-workflows":
          navSubPage("workflows.html");
          break;
        case "nav-templates":
          navSubPage("playbooks.html?mode=playbookLoad");
          break;
        case "nav-chat":
          navSubPage("chat.html");
          break;
        case "nav-search":
          navSubPage("playbooks.html?mode=clauseSearch");
          break;
        case "nav-edit-document":
          // navSubPage("edit_document.html");
          navToEditDocument();
          break;
        case "nav-traffic-lights":
          navSubPage("traffic_lights.html");
          break;
      }
    };
  });

  // ######################## CHAT WITH DOCUMENT MAIN #########################
  divLlmOutputArea = document.getElementById("llm-output-area") as HTMLDivElement;
  llmInputArea = document.querySelector(".llm-input-area") as HTMLDivElement;
  textareaLlmInput = document.getElementById("textarea-llm-input") as HTMLTextAreaElement;
  buttonSend = document.getElementById("button-send") as HTMLButtonElement;
  selectLlmModel = document.getElementById("select-llm-model") as HTMLSelectElement;

  textareaLlmInput.oninput = () => {
    checkInput();
  };
  selectLlmModel.onchange = () => checkInput();

  mainIOElement = new IOMain(divLlmOutputArea, taskCategory);
  buttonSend.onclick = () => {
    morphToChat();
    sendChatMessage();
  };
  // ##########################################################################

  // ######################## QUICK ACTIONS ###################################
  btnSummarizeQuick = document.getElementById("btn-summarize-quick") as HTMLButtonElement;
  btnSummarizeQuick.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("summarize.html");
  };

  btnWorkflowsQuick = document.getElementById("btn-workflows-quick") as HTMLButtonElement;
  btnWorkflowsQuick.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("workflows.html");
  };
  // ##########################################################################

  // ######################## SUMMARIZE (compatibility) ######################
  btnSummarize = document.getElementById("btn-summarize") as HTMLButtonElement;
  if (btnSummarize) {
    btnSummarize.onclick = async () => {
      await mainIOElement.activeSearchTopic?.deactivate();
      navSubPage("summarize.html");
    };
  }
  // ##########################################################################

  // ######################## WORKFLOWS (compatibility) ######################
  btnWorkflows = document.getElementById("btn-workflows") as HTMLButtonElement;
  if (btnWorkflows) {
    btnWorkflows.onclick = async () => {
      await mainIOElement.activeSearchTopic?.deactivate();
      navSubPage("workflows.html");
    };
  }
  // ##########################################################################

  // ######################## EDIT DOCUMENT ###################################
  const navToEditDocument = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("edit_document.html");
  };

  btnEditDocument = document.getElementById("btn-edit-document") as HTMLButtonElement;
  if (btnEditDocument) {
    btnEditDocument.onclick = navToEditDocument;
  }

  const specialWorkflows = getSpecialWorkflows();
  Object.entries(specialWorkflows).forEach(([name, id]) => {
    if (!id) return;

    const specialEditButton = document.createElement("button");
    specialEditButton.classList.add("function-btn", "with-icon");
    specialEditButton.type = "button";

    const icon = document.createElement("i");
    icon.classList.add("fa", "fa-edit");

    const span = document.createElement("span");
    // span.setAttribute("data-i18n", name);
    span.textContent = translate(camelToKebab(name));

    specialEditButton.appendChild(icon);
    specialEditButton.appendChild(span);

    specialEditButton.onclick = async () => {
      sessionStorage.setItem("editDocumentMode", name);
      navToEditDocument();
    };

    editDocumentContainer.appendChild(specialEditButton);
  });

  // ##########################################################################

  // ######################## CHAT ############################################
  btnChat = document.getElementById("btn-chat") as HTMLButtonElement;
  if (btnChat) {
    btnChat.onclick = async () => {
      await mainIOElement.activeSearchTopic?.deactivate();
      navSubPage("chat.html");
    };
  }
  // ##########################################################################

  // ######################## PLAYBOOKS #######################################
  btnLoadDocument = document.getElementById("btn-load-document") as HTMLButtonElement;
  btnLoadDocument.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("playbooks.html?mode=playbookLoad");
  };

  btnSaveDocument = document.getElementById("btn-save-document") as HTMLButtonElement;
  btnSaveDocument.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("playbooks.html?mode=playbookSave");
  };

  btnLoadClause = document.getElementById("btn-load-clause") as HTMLButtonElement;
  btnLoadClause.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("playbooks.html?mode=clauseLoad");
  };

  btnSearchClause = document.getElementById("btn-search-clause") as HTMLButtonElement;
  btnSearchClause.onclick = async () => {
    await mainIOElement.activeSearchTopic?.deactivate();
    navSubPage("playbooks.html?mode=clauseSearch");
  };
  // ##########################################################################

  // ######################## FUNCTION CATEGORIES TOGGLE ####################
  const categoryHeaders = document.querySelectorAll(".category-header");
  categoryHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling as HTMLElement;
      const toggle = header.querySelector(".category-toggle") as HTMLElement;

      if (content.classList.contains("open")) {
        content.classList.remove("open");
        toggle.style.transform = "rotate(-180deg)";
      } else {
        content.classList.add("open");
        toggle.style.transform = "rotate(0deg)";
      }
    });
  });

  // ######################## FUNCTION BUTTONS ################################
  // CHANGED TO SEPARATE WORKFLOWS
  // const functionButtons = document.querySelectorAll(".function-btn");
  // functionButtons.forEach((button) => {
  //   if (!button.id) {
  //     button.addEventListener("click", () => {
  //       // Handle function button clicks for AI editing functions
  //       const text = button.textContent?.trim();
  //       if (text) {
  //         textareaLlmInput.value = `Bitte bearbeiten Sie das Dokument auf folgende Art: ${text}`;
  //         checkInput();
  //         buttonSend.click();
  //       }
  //     });
  //   }
  // });

  // ######################## SETTINGS ########################################

  settingsElement = new SettingsElement();
  footer.prepend(settingsElement.elem());

  // ######################## AUDIO RECORDING #################################

  voiceRecorderButton = new VoiceRecorderButton(async (file: File, duration: number) => {
    // console.log("Aufnahme beendet. Dauer:", duration, "Sekunden");

    // const audioUrl = URL.createObjectURL(blob);
    // const audio = new Audio(audioUrl);
    // audio.play().catch((error) => {
    //   console.error("Fehler beim Abspielen:", error);
    // });

    if (duration <= 1) return;
    checkInput(true);
    voiceRecorderButton.setIsLoading(true);
    try {
      textareaLlmInput.value = (await postAudioRecording(file)).trim();
    } catch (error) {
      console.error(error);
      toastMessage(translate("error-request-response"), "error");
    }
    checkInput();
    voiceRecorderButton.setIsLoading(false);
  });
  buttonSend.insertAdjacentElement("beforebegin", voiceRecorderButton.getElement());

  // ######################## FILE UPLOAD #####################################

  const inputButtonContainerList = document.getElementsByClassName("input-button-container");
  inputFileContainer = document.getElementById("input-file-container") as HTMLDivElement;

  fileUploadElement = new FileUploadElement(
    caseCreationCallback,
    checkInput,
    getDocumentFile,
    taskCategory,
    "document_chat"
  );
  inputButtonContainerList[0].prepend(fileUploadElement.elem());
  inputFileContainer.append(fileUploadElement.getFileListElement());

  checkInput();
}

function checkInput(isBusy: boolean = false): void {
  const textIsReady = textareaLlmInput.value.length > 0;
  if (!chatIsOpen) {
    if (textIsReady) {
      // buttonSend.classList.remove("hidden");
    } else {
      // buttonSend.classList.add("hidden");
    }
  }
  const readyVal =
    isBusy ||
    !textIsReady ||
    selectLlmModel.selectedIndex < 0 ||
    selectLlmModel.classList.contains("loading");
  buttonSend.disabled = readyVal;

  selectLlmModel.disabled = isBusy;

  voiceRecorderButton.button.disabled = isBusy;
}

async function populate(): Promise<void> {
  console.log("Populating menu view...");
  await Word.run(async (context) => {
    try {
      models = getModels();
      await populateModelSelection(
        models.getAllLlmModelsDetailed(),
        selectLlmModel,
        "document_chat"
      );
    } catch (error) {
      console.error(error);
      toastMessage(translate("error-service-not-available"), "error");
    }

    const propCaseIdDocumentChat =
      context.document.properties.customProperties.getItemOrNullObject("case_id_document_chat");
    await context.sync();

    if (!propCaseIdDocumentChat.isNullObject) {
      // mainIOElement.grow();

      propCaseIdDocumentChat.load("value");
      await context.sync();
      caseIdDocumentChat = propCaseIdDocumentChat.value;

      if (caseIdDocumentChat !== null) {
        fileUploadElement.setCaseId(caseIdDocumentChat);
      }
    } else {
      mainIOElement.applyTaskFilter(taskCategory);
    }
  });

  // testing instant morph
  if (document.location.hash == "#documentChat") morphToChat(true);
}

async function morphToChat(instant?: boolean): Promise<void> {
  try {
    if (instant) {
      document.documentElement.style.setProperty("--transition-duration", "0ms");
    }

    // Hide welcome section and menu options
    // divWelcome.classList.add("hidden", "gone");
    menuOptionsContainer.classList.add("hidden", "gone");
    // app-header
    header.classList.add("hidden", "gone");

    // Hide quick actions
    const quickActions = document.querySelector(".quick-actions") as HTMLElement;
    if (quickActions) {
      quickActions.classList.add("hidden");
    }

    // Hide sidebar navigation
    const sidebar = document.querySelector(".left-sidebar") as HTMLElement;
    if (sidebar) {
      sidebar.classList.add("hidden");
    }

    // Switch headers
    header.classList.add("hidden"); // Hide menu header
    const chatHeader = document.querySelector(".chat-header") as HTMLElement;
    if (chatHeader) {
      chatHeader.classList.remove("gone", "hidden"); // Show chat header
    }

    setTimeout(
      async () => {
        menuOptionsContainer.remove();
        if (quickActions) quickActions.remove();
        if (sidebar) sidebar.remove();
      },
      instant ? 0 : 533
    );

    // Show LLM output area
    divLlmOutputArea.classList.remove("hidden");
    mainIOElement.grow();

    // Update main content layout
    const main = document.getElementsByTagName("main")[0];
    main.classList.remove("menu-page");
    main.classList.add("task-page");

    // Expand input area to full width
    llmInputArea.style.maxWidth = "100%";

    if (caseIdDocumentChat !== null && !chatIsOpen) {
      console.log("Loading saved document chat history...");
      await loadCaseMessages(caseIdDocumentChat, mainIOElement, "document", taskCategory);
    }

    chatIsOpen = true;
  } catch (error) {
    console.error(error);
    toastMessage(translate("error-service-not-available"), "error");
  }
}

export async function saveCaseId(caseId: string) {
  console.log(`Saving document-chat (menu) caseId: ${caseId}`);
  return Word.run(async (context) => {
    try {
      caseIdDocumentChat = caseId;
      context.document.properties.customProperties.add("case_id_document_chat", caseIdDocumentChat);
      await context.sync();

      fileUploadElement.setCaseId(caseIdDocumentChat);
    } catch (error) {
      console.error(error);
      toastMessage(translate("error-case-creation"), "error");
      checkInput(true);
      mainIOElement.hideAllLoadingIndicators();
    }
  });
}

async function caseCreationCallback(caseId: string): Promise<void> {
  await saveCaseId(caseId);

  await Word.run(async (context) => {
    context.document.properties.customProperties.add(
      "current_llm_model_index_document_chat",
      selectLlmModel.selectedIndex
    );

    // const selectedLlmModelId: string = selectLlmModel.item(selectLlmModel.selectedIndex)!.value;
    // const selectedLlmModel: LlmModelDetailed = modelsDetailedDict[selectedLlmModelId];

    // context.document.properties.customProperties.add(
    //   "llm_server_url_document_chat",
    //   selectedLlmModel.serverUrl
    // );
    // context.document.properties.customProperties.add(
    //   "llm_server_document_chat",
    //   selectedLlmModel.server
    // );

    await context.sync();

    await populateModelSelection(models.getAllLlmModelsDetailed(), selectLlmModel, "document_chat");
  });
}

// function getCurrentModelServerUrl(): string {
//   try {
//     const selectedLlmModelId: string = selectLlmModel.item(selectLlmModel.selectedIndex)!.value;
//     const selectedLlmModel: LlmModelDetailed = modelsDetailedDict[selectedLlmModelId];
//     return selectedLlmModel.serverUrl;
//   } catch (error) {
//     console.log(error);
//     throw new Error(translate("error-llm-loading"));
//   }
// }

async function getDocumentFile(): Promise<documentFile> {
  const contentFile = await getContentFile();
  await setOriginalDocumentHash(taskCategory);
  return contentFile;
}

async function sendChatMessage(): Promise<void> {
  return Word.run(async (context) => {
    try {
      checkInput(true);
      const ragInput = textareaLlmInput.value;
      textareaLlmInput.value = "";

      const selectedLlmModelId: string = selectLlmModel.item(selectLlmModel.selectedIndex)!.value;
      const selectedLlmModel: LlmModelDetailed = modelsDetailedDict[selectedLlmModelId];

      if (caseIdDocumentChat === null) {
        // check if indicator is needed
        // const indicatorCreateCase = showLoadingIndicator(
        //   mainIOElement.mainContainer,
        //   "Ihr Fall wird erstellt. Bitte warten..."
        // );

        // selectedLlmModel.serverUrl
        const createResponse: V2CreateResponse = await createCaseWithFiles();

        await setOriginalDocumentHash(taskCategory);

        await caseCreationCallback(createResponse.case_id);

        // hideLoadingIndicator(mainIOElement.mainContainer, indicatorCreateCase);
      } else {
        const documentContentChanged = await isDocumentChanged(taskCategory);

        if (documentContentChanged) {
          const docID = await getLlmCaseDocumentId(caseIdDocumentChat);
          if (docID !== null) {
            await updateDocumentContent(docID, await getDocContentWithComments());
            await setOriginalDocumentHash(taskCategory);
          } else {
            // no document id found - maybe throw error?
            console.warn("No document ID found for case, skipping content update.");
          }
        }

        context.document.properties.customProperties.add(
          "current_llm_model_index_document_chat",
          selectLlmModel.selectedIndex
        );
        await context.sync();
      }

      const totalLength = ragInput.length + (await getDocContentWithComments()).length;
      const contextWindowGuess = Math.min(
        Math.ceil(totalLength / 2 / (selectedLlmModel.max_context_window / 4)) *
          (selectedLlmModel.max_context_window / 4),
        selectedLlmModel.max_context_window
      );

      const llmStreamV2body: LLMStreamV2body = {
        prompt: ragInput,
        model: selectedLlmModel.name,
        type: "complete_document",
        context_window: contextWindowGuess,
      };

      const llmStreamV2Params: LLMStreamV2Params = {
        endpointPath: `chat/${caseIdDocumentChat}`,
        model: selectedLlmModel.name,
        llmStreamV2body: llmStreamV2body,
      };

      makeLlmRequestV2(mainIOElement, checkInput, llmStreamV2Params);
    } catch (error: any) {
      if (error instanceof ce.CaseCreationError) return;
      console.error(error);
      toastMessage(translate("error-request-response"), "error");
    }
  });
}
